import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { EntityrecordApi, DataelementApi, PicklistApi } from '../../sdk/services/custom';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from 'lodash';
import { evalExpression } from 'ng-formly/src/core/utils';
import { LoopBackAuth } from '../../sdk/services/core/auth.service';
import { PlatformApp } from '../../services/app.service';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs/Subject';

/*
This custom field is used to select options for an app.
*/

@Component({
	selector: 'formly-field-input',
	template: `
	<i *ngIf="icon" [class]="icon"></i>
	<a *ngIf="required"><font color="red"> *</font></a>
	<div class="btn-group" *ngIf="!readonly">
		<a class="btn btn-secondary btn-sm" *ngIf="apiData" (click)="refreshOptions()" 
		data-toggle="tooltip" data-placement="top" title="Refresh" style="color:DODGERBLUE;border:none;">
			<i class="fa fa-refresh" aria-hidden="true"></i>
		</a>
	</div>
    <input *ngIf="!readonly" [type]="type" [formControl]="formControl" class="form-control" 
	  [formlyAttributes]="field" [ngClass]="{'form-control-danger': valid}">
	<div *ngIf="readonly" style="padding-top:3px;">
		<label *ngIf="type != 'url'" class="text-info" >{{dataLabel}}</label>
		<a style="user-select:none" *ngIf="type == 'url'" (click)="forceDownload(model[key])">
			<label class="text-info">{{dataLabel}}</label>
		</a>
	<div>
    `,
})

export class InputField extends FieldType implements OnInit, OnDestroy {
	public formulae = [];
	public dataelementfilters = [];
	public modelValues = [];
	public downloadableurl: string;
	public currentuser;
	public appId;
	public apiData = false;
	public dataLabel;
	public basecurrency = '';
	public defaultcurrency = '';
	public exchangerate = 1;
	public ngUnsubscribe: Subject<void> = new Subject<void>();

	get type() {
		return this.to.type || 'text';
	}

	get readonly() {
		return this.to.readonly || false;
	}

	get required() {
		return this.to.required || false;
	}

	get icon() {
		return this.to.icon || null;
	}

	get downloadable() {
		return this.to.downloadable || null;
	}

	constructor(public _LoopBackAuth: LoopBackAuth,
		public _PlatformApp: PlatformApp,
		public _DataelementApi: DataelementApi,
		public _PicklistApi: PicklistApi,
		public _EntityrecordApi: EntityrecordApi) {
		super();
	}

	ngOnInit() {
		this.currentuser = this._LoopBackAuth.getCurrentUserData();
		if (PlatformApp.getAppVariable('platformApp')) {
			this.appId = PlatformApp.getAppVariable('referenceAppId');
		} else { this.appId = this.currentuser.appId; }

		if (this.form['appData'] && this.form['appData']['defaultcurrency']) {
			this.defaultcurrency = this.form['appData']['defaultcurrency'];
		}
		if (this.form['viewMode']) {
			this.setDataLabel();
		} else {
			if (!this.form['subscriptions']) { this.form['subscriptions'] = []; }

			if (!this.form['newcontrols']) { this.form['newcontrols'] = {}; }

			for (let key in this.form.controls) {
				if (this.form.controls[key]) { this.form['newcontrols'][key] = this.form.controls[key]; }
			}

			if (this.field['formulae']) { this.formulae = this.field['formulae']; }

			if (this.field['dataelementfilters']) { this.dataelementfilters = this.field['dataelementfilters']; }

			if (this.field.formControl) { this.addWatcher(this.field.formControl); }

			if (this.field['validate']) {
				this.to.operation = this.field['validate']['operation'];
				this.to.checkerfield = this.field['validate']['field'];
				this.addValidateWatcher(this.field.formControl);
			}

			if (this.to.readonly) { this.to.disabled = true; }

			if (this.field.defaultValue && !this.model[this.key]) { this.formControl.setValue(this.field.defaultValue); }

			if (this.model[this.key]) {
				this.formControl.setValue(this.model[this.key]);
				if (this.field['formulae']) {
					this.processFormulae(this.model[this.key]);
				}
				if (this.field['dataelementfilters']) {
					this.processDataElementFilter(this.model[this.key]);
				}
			}

			// Set DataLabel
			if (this.readonly) { this.setDataLabel(); }

			// Set Lookup Value
			if (this.field['parentLookupField'] && this.field['parentLookupDataField']) {
				this.apiData = true;
				if (this.model && this.model[this.field["parentLookupField"]]) { this.pullLookupData(this.model[this.field["parentLookupField"]]); }
				this.setNewFormControl(this.field['parentLookupField']);
				if (this.form.controls[this.field["parentLookupField"]]) {
					this.form['subscriptions'].push(this.form.controls[this.field["parentLookupField"]].valueChanges
						.subscribe((parentLookupFieldValue: any) => {
							this.pullLookupData(parentLookupFieldValue);
						}));
				}
			}
			this.refreshOptions();
		}
	}

	public refreshOptions() {
		if (this.field['parentLookupField'] && this.field['parentLookupDataField']) {
			if (this.model && this.model[this.field["parentLookupField"]]) {
				this.pullLookupData(this.model[this.field["parentLookupField"]]);
			}
		}

		if (this.to.textlookup && this.field['textLookupField']) {
			this.pullLookupLabel(this.field['textLookupField']);
		} else if (this.to.textpicklist && this.field['textPicklistId']) {
			this.pullPicklistLabel(this.field['textPicklistId']);
		}
	}

	public pullLookupData(parentLookupFieldValue) {
		if (parentLookupFieldValue) {
			this.form['subscriptions'].push(this._EntityrecordApi.findById(parentLookupFieldValue)
				.subscribe((record) => {
					if (record && record['data'] && record['data'][this.field['parentLookupDataField']]) {
						this.formControl.setValue(record['data'][this.field['parentLookupDataField']]);
					}
				}));
		}
	}

	public pullLookupLabel(textLookupField) {
		if (this.model && this.model[this.key])
			this.form['subscriptions'].push(this._EntityrecordApi.findById(this.model[this.key])
				.subscribe((record) => {
					if (record && record['data'] && record['data'][this.field['textLookupField']])
						this.dataLabel = record['data'][this.field['textLookupField']];
				}));
	}

	public pullPicklistLabel(textPicklistId) {
		if (this.model && this.model[this.key] && textPicklistId)
			this.form['subscriptions'].push(this._PicklistApi.findById(textPicklistId)
				.subscribe((picklist) => {
					if (picklist && picklist['options'] && picklist['options'].length && picklist['options'].length > 0) {
						let record = _.find(picklist['options'], { "value": this.model[this.key] });
						if (record && record['label'])
							this.dataLabel = record['label'];
					}
				}));
	}

	public addValidateWatcher(formControl) {
		if (this.model && this.model[this.key] && this.model[this.to.checkerfield])
			if (!(PlatformApp.validateValue(this.model[this.key], this.model[this.to.checkerfield], this.to.operation)))
				this.setFormError('validateError');
		this.setNewFormControl(this.to.checkerfield);
		if (this.form.controls[this.to.checkerfield]) {
			this.form['subscriptions'].push(this.form.controls[this.to.checkerfield].valueChanges
				.subscribe((checkervalue: any) => {
					if (this.model && this.model[this.key])
						if (!(PlatformApp.validateValue(this.model[this.key], checkervalue, this.to.operation)))
							this.setFormError('validateError');
				}));
		}
	}

	public addWatcher(formControl) {
		this.form['subscriptions'].push(formControl.valueChanges
			.takeUntil(this.ngUnsubscribe)
			.subscribe((updatedValue: any) => {
				// if (updatedValue !== this.model[this.key]) {
				if (this.field['formulae'])
					this.processFormulae(updatedValue);
				if (this.field['dataelementfilters'])
					this.processDataElementFilter(updatedValue);
				if (this.model && this.model[this.to.checkerfield])
					if (!(PlatformApp.validateValue(updatedValue, this.model[this.to.checkerfield], this.to.operation)))
						this.setFormError('validateError');

				if (this.to.textlookup && this.field['textLookupField'])
					this.pullLookupLabel(this.field['textLookupField']);
				else if (this.to.textpicklist && this.field['textPicklistId'])
					this.pullPicklistLabel(this.field['textPicklistId']);
				else
					this.setDataLabel();
				// }
			}));
	}

	public processFormulae(currentValue) {
		for (let i = 0; i < this.formulae.length; i++) {
			let formula = this.formulae[i];
			if (this.setModelValues(formula['fields'], currentValue)) {
				this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
			}
		}
	}

	public processDataElementFilter(currentValue) {
		let filter: LoopBackFilter = <LoopBackFilter>{};
		filter['data'] = true;
		let filterfields = {};
		for (let i = 0; i < this.dataelementfilters.length; i++) {
			let dataelementfilter = this.dataelementfilters[i];
			let lookupfield = dataelementfilter.lookupfield;
			let resultfield = dataelementfilter.resultfield;
			let filters = dataelementfilter.filters;
			let resultkey = dataelementfilter.resultkey;

			let requiredFieldsExist = true;
			for (let key in filters) {
				if (!this.model[key]) {
					requiredFieldsExist = false;
					break;
				} else {
					if (key === this.field.key) { filter[filters[key]] = currentValue; }
					else { filter[filters[key]] = this.model[key]; }
				}
			}
			if (requiredFieldsExist) {
				this.form['subscriptions'].push(this._DataelementApi.findById(lookupfield, filter)
					.subscribe((dataelement) => {
						if (dataelement && dataelement['data'] && dataelement['data'][0]) {
							if (dataelement['data'][0][resultkey]) {
								if (this.form.controls[resultfield]) {
									this.form.controls[resultfield].setValue(dataelement['data'][0][resultkey]);
									if (this.form['newcontrols'][resultfield] && !this.model[resultfield]) {
										this.form.setControl(resultfield, this.form['newcontrols'][resultfield]);
										this.form.controls[resultfield].setValue(dataelement['data'][0][resultkey]);
									}
								} else {
									if (this.form['newcontrols'][resultfield]) {
										this.form.addControl(resultfield, this.form['newcontrols'][resultfield]);
										this.form.controls[resultfield].setValue(dataelement['data'][0][resultkey]);
									} else { this.model[resultfield] = dataelement['data'][0][resultkey]; }
								}
							}
						}
					}));
			}
		}
	}

	protected forceDownload(url) {
		let xhr = new XMLHttpRequest();
		xhr.open("GET", url, true);
		//xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
		if (this.to.isAws) { 
			//xhr.setRequestHeader('Authorization', '');
		}
		xhr.responseType = "blob";
		xhr.onload = function () {
			var urlCreator = window.URL;
			var imageUrl = urlCreator.createObjectURL(xhr.response);
			var tag = document.createElement('a');
			tag.href = imageUrl;
			tag.download = url.substring(url.lastIndexOf("/") + 1);
			document.body.appendChild(tag);
			tag.click();
			document.body.removeChild(tag);
		}
		xhr.onerror = function () {
			console.error('Error in accessing the file to download');
		}
		xhr.send();
	}

	public setFormError(errorKey) {
		let error = {};
		error[errorKey] = true;
		this.form['formValidity'] = false;
		if (this.form.controls[this.key]) {
			this.form.controls[this.key].markAsTouched();
			this.form.controls[this.key].setErrors(error);
		}
	}

	public setModelValues(fieldArray, updatedValue) {
		let requiredFieldsExist = true;
		this.modelValues = [];
		for (let j = 0; j < fieldArray.length; j++) {
			if (!this.model[fieldArray[j]]) {
				requiredFieldsExist = false;
				break;
			} else {
				if (fieldArray[j] === this.field.key) {
					this.modelValues.push(updatedValue);
				} else {
					this.modelValues.push(this.model[fieldArray[j]]);
				}
			}
		}
		return requiredFieldsExist;
	}

	public setResults(resultArray, value): void {
		for (let i = 0; i < resultArray.length; i++) {
			let resultField = resultArray[i];
			if (this.form.controls[resultField]) {
				this.form.controls[resultField].setValue(value);

				if (this.form['newcontrols'][resultField] && !this.model[resultField]) {
					this.form.setControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				}
			} else {
				if (this.form['newcontrols'][resultField]) {
					this.form.addControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				} else {
					this.model[resultField] = value;
				}
			}
		}
	}

	public getValue(field: any, subfield: string) {
		if (field['templateOptions'] && field['templateOptions'][subfield]) {
			return field['templateOptions'][subfield];
		}
		if (field['expressionProperties'] && (field['expressionProperties'].hasOwnProperty(subfield))) {
			return evalExpression(field['expressionProperties'][subfield].expression, this, [this.model, this.options.fromState]);
		}
		if (field[subfield]) {
			return field[subfield];
		}
		return null;
	}

	public setNewFormControl(fieldname: string) {
		if (this.form['newcontrols'][fieldname]) {
			if (!this.form.controls[fieldname]) {
				this.form.addControl(fieldname, this.form['newcontrols'][fieldname]);
			} else { this.form.setControl(fieldname, this.form['newcontrols'][fieldname]); }
		} else { console.log('Error !!! No Form Control for Field: "' + fieldname + '" in input-field of "' + this.key + '"'); }
	}

	ngOnDestroy() {
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}

	public getFormattedDate(datestring) {
		let dateValue = new Date(datestring);
		let mm = dateValue.getMonth() + 1;
		let month = mm < 10 ? "0" + mm : mm;
		let dd = dateValue.getDate();
		let day = dd < 10 ? "0" + dd : dd;
		let year = dateValue.getFullYear();
		return day + "/" + month + "/" + year;
	}

	public getFormattedDateTime(datetimestring) {
		let dateValue = new Date(datetimestring);
		let mm = dateValue.getMonth() + 1;
		let month = mm < 10 ? "0" + mm : mm;
		let dd = dateValue.getDate();
		let day = dd < 10 ? "0" + dd : dd;
		let year = dateValue.getFullYear();
		let hour = dateValue.getHours();
		let min = dateValue.getMinutes();
		return day + "/" + month + "/" + year + ' ' + hour + ':' + min;
	}

	public setDataLabel() {
		if (this.model && this.model['currency']) { this.basecurrency = this.model['currency']; }
		if (this.basecurrency && this.form['appData'] && this.form['appData']['currencydata'] && this.form['appData']['currencydata'].length) {
			let currencyObj = _.find(this.form['appData']['currencydata'], { "currency": this.basecurrency, 'exchange': this.defaultcurrency });
			if (currencyObj && currencyObj['rate']) { this.exchangerate = currencyObj['rate']; }
		}

		if (!this.model[this.key] && this.model[this.key] !== 0 && this.model[this.key] !== '0')
			this.dataLabel = '';
		else {
			switch (this.to.type) {
				case 'date':
					if (typeof this.model[this.key] == 'string') {
						this.dataLabel = this.getFormattedDate(this.model[this.key]);
					} else if (typeof this.model[this.key] == 'object' && this.model[this.key].display) {
						this.dataLabel = this.model[this.key].display;
					} else { this.dataLabel = this.model[this.key]; }
					break;
				case 'dateandtime':
					if (typeof this.model[this.key] == 'string')
						this.dataLabel = this.getFormattedDateTime(this.model[this.key]);
					else if (typeof this.model[this.key] == 'object' && this.model[this.key].display)
						this.dataLabel = this.model[this.key].display;
					else
						this.dataLabel = this.model[this.key];
					break;
				case 'number':
					if (this.to.subtype == 'currency') {
						if (this.form['viewMode'] && this.defaultcurrency && this.basecurrency && this.exchangerate !== 1 && this.model[this.key]) {
							try {
								let converteddata;
								if (typeof this.model[this.key] == 'string')
									converteddata = Number(Number(this.model[this.key].split(' ')[1]) * this.exchangerate).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
								else
									converteddata = Number(this.model[this.key]).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
								this.dataLabel = this.basecurrency + ' ' + this.model[this.key].split(' ')[1] + ' > ' + this.defaultcurrency + ' ' + converteddata.toFixed(2).toString();
							} catch (error) {
								this.dataLabel = this.model[this.key];
							}
						} else {
							if (typeof this.model[this.key] == 'string')
								this.dataLabel = this.model[this.key];
							else {
								if (this.basecurrency) {
									this.dataLabel = this.basecurrency + ' ' + Number(this.model[this.key]).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
								} else {
									this.dataLabel = Number(this.model[this.key]).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
								}
							}
						}
					} else if (this.to.subtype == 'percent') {
						if (typeof this.model[this.key] == 'string') {
							this.dataLabel = this.model[this.key];
						} else { this.dataLabel = Number(this.model[this.key]).toFixed(2) + "%"; }
					} else {
						this.dataLabel = this.model[this.key];
					}
					break;
				case 'url':
					let k = this.model[this.key];
					let i = k.lastIndexOf("/");
					if (i != -1) {
						this.dataLabel = k.substring(i + 1);
					}
					this.downloadableurl = k.substring(k.indexOf("//") + 1)
					break;
				default:
					if (typeof this.model[this.key] == 'object' && this.model[this.key].display) {
						this.dataLabel = this.model[this.key].display;
					} else if (typeof this.model[this.key] == 'object') {
						this.dataLabel = JSON.stringify(this.model[this.key]);
					} else { this.dataLabel = this.model[this.key]; }
					break;
			}
		}
	}
}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/inputfield.ts